import { mixpanel, optimove, facebook, ga } from 'js/analytics/adapters'
import goalTypes from './goalTypes'
import { MALE } from 'js/genders'
import { calculateBMI } from 'js/utils'

export const trackCompleteRegistration = ({
  profile,
  type,
  duration,
  flowName,
  method,
  language,
  country,
}) => {
  const userId = String(profile.id)
  const goalType = goalTypes[profile.goal]
  const gender = profile.gender === MALE ? 'Male' : 'Female'
  const age = parseInt(profile.age)
  const weight = parseInt(profile.weight)
  const height = parseInt(profile.height)
  const goalWeight = profile.goalWeight && parseInt(profile.goalWeight)
  const bmi = calculateBMI(profile.weight, profile.height)
  const goalBmi = calculateBMI(profile.goalWeight, profile.height)

  ga.track('Complete Registration')
  mixpanel.track('Complete Registration', {
    'Account Type': type,
    'Flow Name': flowName,
  })

  mixpanel.alias({ userId })

  mixpanel.people({
    userProperties: {
      'Goal Type': goalType,
      Gender: gender,
      Age: age,
      Weight: weight,
      Height: height,
      'Registration Date': new Date().toISOString(),
      'Registration Method': method,
      'Goal Weight': goalWeight,
      BMI: bmi,
      'Goal BMI': goalBmi,
      'Marketing Consent': true,
      'Email Validated': false,
      'Account Type': type,
      'User ID': userId,
      'Subscription Duration': duration,
    },
  })
  mixpanel.register({
    superProperties: {
      'Account Type': 'Free',
      'User ID': userId,
      'Subscription Duration': duration,
    },
  })

  optimove.user({
    id: userId,
    email: profile.email,
    eventName: 'signup',
    parameters: {
      source: 'create account',
    },
  })

  optimove.track('complete_registration', {
    goal_type: goalType,
    first_name: profile.firstName,
    gender,
    age,
    weight,
    height,
    registration_method: method,
    goal_weight: goalWeight,
    bmi,
    goal_bmi: goalBmi,
    marketing_consent: true,
    email_validated: false,
    account_type: type,
    user_id: userId,
    app_language: language,
    country,
  })

  facebook.track('CompleteRegistration')
}
